/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'


import DeleteModal from '../modals/deleteModal'

function CustomerInvoiceActionButton(props) {

    const [openBox, setopenBox] = useState(false)

    let handleDelete = () => {
        props.data.deleteCustomerInvoice(props.data.refNo)
    }

    let handleEdit = (e) => {
        let customerInvoice = props.data
        let history = props.agGridReact.props.baseURL.history
        history.push({ pathname: '/edit-customerinvoice', state: { id: customerInvoice.refNo, billingPartyCode: customerInvoice.customerCode, invoiceId: customerInvoice.invoiceId } })
    }

    let handleOpenDelete = (e) => {
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    const customerInvoiceData = props.data;

    const handleView = (e) => {
        const customerInvoice = props.data
        const history = props.agGridReact.props.baseURL.history
        history.push({ pathname: '/view-invoice', state: { id: customerInvoice.refNo, billingPartyCode: customerInvoice.customerCode, invoiceId: customerInvoice.invoiceId } })
    };

    return (
        <>
            <Button onClick={handleView} basic size="mini" type="button" icon> <Icon name="eye" color="blue" /></Button>
            <Button disabled={customerInvoiceData?.approve_status == 1 ? true : false} onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={customerInvoiceData?.approve_status == 1 || customerInvoiceData?.statusId > 1 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} isLoading={props.data.isLoading} />
        </>
    )
}

export default CustomerInvoiceActionButton
